import styled from "@emotion/styled";
import { Button, IconButton } from "@mui/material";
import { COLORS } from "shared/constants/AppEnums";

export const ButtonContained = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(COLORS.primary),
    backgroundColor: COLORS.primary,
    '&.Mui-disabled': {
        backgroundColor: theme.palette.action.disabledBackground,
        color: theme.palette.getContrastText(theme.palette.action.disabledBackground),
    },
    '&:hover': {
        backgroundColor: COLORS.hover,
    },
}));

export const ButtonOutlined = styled(Button)(() => ({
    color: COLORS.primary,
    borderColor: COLORS.primary,
    '&:hover': {
        borderColor: COLORS.hover,
        backgroundColor: '#fff',
    },
}));

export const IconButtonNoAction = styled(IconButton)(() => ({
    backgroundColor:'#FFF9ED', 
    color:'#F6AD1D',
    '&:hover': {
        backgroundColor:'#FFF9ED', 
        color:'#F6AD1D',
    },
    cursor: 'default'
}));